<template>
  <header class="app-header">
    <div class="app-header-left">
      <h6 class="app-header-title">{{ pageTitle }}</h6>
    </div>
    <div class="app-header-right">
      <span class="app-header-date">{{ formattedDate }}</span>
      <div class="app-header-avatar">{{ initials }}</div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  computed: {
    user () { return this.$store.getters['auth/user'] },
    pageTitle () { return this.$route.meta?.title || 'ubuHle' },
    initials () {
      if (!this.user) return '?'
      return `${this.user.firstName?.[0] || ''}${this.user.lastName?.[0] || ''}`.toUpperCase()
    },
    formattedDate () {
      return new Date().toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' })
    }
  }
}
</script>

<style scoped>
.app-header {
  height: 60px;
  background: #212121;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  position: sticky;
  top: 0;
  z-index: 100;
  flex-shrink: 0;
}
.app-header-title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.2px;
}
.app-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}
.app-header-date {
  font-size: 0.78rem;
  color: rgba(255,255,255,0.4);
}
.app-header-avatar {
  width: 34px; height: 34px;
  background: rgb(255, 152, 0);
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: default;
}
</style>
